import { createSlice } from "@reduxjs/toolkit";
const intialSelectedLanguage =  {selectedLanguageData:{selected: 'en'}};

export const selectedLanguageSlice = createSlice({
  name: "selectedLanguage",
  initialState: intialSelectedLanguage,
  reducers: {
    setSelectedLanguageState(state, action) {
        state.selectedLanguageData = { ...state.selectedLanguage, ...action.payload };
    },
    resetSelectedLanguageState(state) {
     // state.personData = {};
     return intialSelectedLanguage;
    }
  },
});
